import { useState, useEffect } from 'react';
import { reportError } from '@/observability/clientLogger';

function getRelayUrl(): string | null {
  try {
    const node = localStorage.getItem('node');
    if (node) {
      const base = window.location.hostname.split('.').slice(-2).join('.');
      const url = `https://${node}.${base}/casefiles/vessel-relay.html`;
      return url;
    }
    reportError(new Error('No node in localStorage; relay iframe will not mount'), { event_detail: 'vessel_relay_no_node' });
  } catch (e) {
    reportError(e, { event_detail: 'vessel_relay_url_failed' });
  }
  return null;
}

export default function VesselRelay() {
  const [relayUrl, setRelayUrl] = useState<string | null>(null);

  useEffect(() => {
    const url = getRelayUrl();
    setRelayUrl(url);
    if (!url) {
      reportError(new Error('Relay iframe not mounted; Casefiles will not receive vessel changes'), {
        event_detail: 'vessel_relay_not_mounted',
      });
    }
  }, []);

  if (!relayUrl) return null;

  return (
    <iframe
      src={relayUrl}
      style={{ position: 'fixed', width: 0, height: 0, border: 'none', opacity: 0, pointerEvents: 'none' }}
      aria-hidden="true"
      tabIndex={-1}
      title="vessel-relay"
      onError={() =>
        reportError(new Error('Relay iframe failed to load'), { event_detail: 'vessel_relay_load_failed' })
      }
    />
  );
}
